const TABLE_SIZES = {
  inputs: {
    lg: 11,
    md: 12,
    sm: 13,
    xs: 16
  },
  button: {
    lg: 3,
    md: 3,
    sm: 3,
    xs: 16
  },
  nothing: {
    lg: 3,
    md: 1,
    sm: 0,
    xs: 16
  },
  personalInfo: {
    lg: 16,
    md: 16,
    sm: 16,
    xs: 16
  },
  inputColumn : {
    lg: 8,
    md: 8,
    sm: 8,
    xs: 16
  }
}

export default TABLE_SIZES
